import { useState } from 'react'
import MessageTerminal from './MessageTerminal.jsx'

const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const VALID = 'valid-input'
const INVALID = 'invalid-input'

const initialFields = {
  name: '',
  surname: '',
  email: '',
  subject: '',
  message: '',
}

export default function Contact() {
  const [fields, setFields] = useState(initialFields)
  const [validEmail, setValidEmail] = useState('')
  const [validation, setValidation] = useState({
    nameValidation: '',
    surnameValidation: '',
    emailValidation: '',
    subjectValidation: '',
    messageValidation: '',
  })
  const [allInputsValid, setAllInputsValid] = useState(false)
  const [disabledButton, setDisabledButton] = useState(false)
  const [response, setResponse] = useState(null)
  const [transmitPhase, setTransmitPhase] = useState('idle')

  const setCapitalizedInputs = (event) => {
    let value = event.target.value
    if (event.target.id === 'name' || event.target.id === 'surname') {
      value = value.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase())
    } else if (event.target.id === 'subject') {
      value = value.charAt(0).toUpperCase() + value.substr(1).toLowerCase()
    }
    setFields((current) => ({ ...current, [event.target.id]: value }))
  }

  const handleShowInputState = (event) => {
    if (transmitPhase === 'error') setTransmitPhase('idle')
    const { name, value } = event.target

    if (value.length > 0) {
      if (name === 'email') {
        setFields((current) => ({ ...current, email: value }))
        if (EMAIL_PATTERN.test(String(value).toLowerCase())) {
          setValidEmail(value)
          setValidation((current) => ({ ...current, emailValidation: VALID }))
        } else {
          setValidEmail('')
          setValidation((current) => ({ ...current, emailValidation: INVALID }))
        }
      } else {
        setFields((current) => ({ ...current, [name]: value }))
        setValidation((current) => ({ ...current, [`${name}Validation`]: VALID }))
      }
    } else {
      setFields((current) => ({ ...current, [name]: '' }))
      setValidation((current) => ({ ...current, [`${name}Validation`]: INVALID }))
    }
  }

  const handleCheckValidation = () => {
    const mapping = {
      name: fields.name,
      surname: fields.surname,
      email: validEmail,
      subject: fields.subject,
      message: fields.message,
    }
    let validCount = 0
    const nextValidation = { ...validation }

    for (const key of Object.keys(mapping)) {
      if (mapping[key].length > 0) {
        nextValidation[`${key}Validation`] = VALID
        validCount += 1
      } else {
        nextValidation[`${key}Validation`] = INVALID
      }
    }

    setValidation(nextValidation)
    if (validCount === 5) {
      setAllInputsValid(true)
      return true
    }
    return allInputsValid
  }

  const handleSubmitForm = async (event) => {
    event.preventDefault()
    const isValid = handleCheckValidation()
    if (!isValid) {
      return
    }

    setTransmitPhase('transmitting')

    const body = new URLSearchParams({
      name: fields.name,
      surname: fields.surname,
      email: fields.email,
      subject: fields.subject,
      message: fields.message,
    })

    try {
      const result = await fetch('mail/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      })
      const text = await result.text()
      if (text === 'sent') {
        setTransmitPhase('delivered')
        setResponse(
          <div className="text-center">
            The message has been sent!
            <br />
            Thank you for writing us, we will contact you back soon.
          </div>,
        )
        setDisabledButton(true)
      } else {
        setTransmitPhase('error')
        setResponse(
          <div className="alert alert-danger text-center">An error has ocurred, please try again later.</div>,
        )
      }
    } catch {
      setTransmitPhase('error')
      setResponse(
        <div className="alert alert-danger text-center">An error has ocurred, please try again later.</div>,
      )
    }
  }

  return (
    <div className="mnd-section-container">
      <div className="contact-mnd-mnd-e" id="contact">
        <div className="container">
          <div className="col-md-12 contact-right-mandril">
            <h3>Get in Touch!</h3>
            <div className="contact-columns">
            <div className="col-md-6 col-sm-12 col-xs-12 contact-terminal-col">
              <MessageTerminal
                text={fields.name + fields.surname + fields.email + fields.subject + fields.message}
                phase={transmitPhase}
              />
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12 contact-form-col">
              <div className="contact-span">
                <span>We would love to hear about your ideas!</span>
              </div>
              <form className="contact-form" role="form">
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={fields.name}
                  className={validation.nameValidation}
                  placeholder="Name"
                  onChange={handleShowInputState}
                  onBlur={setCapitalizedInputs}
                />
                <input
                  type="text"
                  name="surname"
                  id="surname"
                  value={fields.surname}
                  className={validation.surnameValidation}
                  placeholder="Surname"
                  onChange={handleShowInputState}
                  onBlur={setCapitalizedInputs}
                />
                <input
                  type="text"
                  name="email"
                  id="email"
                  value={fields.email}
                  className={validation.emailValidation}
                  placeholder="Email"
                  onChange={handleShowInputState}
                />
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  value={fields.subject}
                  className={validation.subjectValidation}
                  placeholder="Subject"
                  onChange={handleShowInputState}
                  onBlur={setCapitalizedInputs}
                />
                <textarea
                  name="message"
                  id="message"
                  value={fields.message}
                  className={validation.messageValidation}
                  placeholder="Message"
                  onChange={handleShowInputState}
                />
                <div className="center form-submit">
                  <a
                    href="#"
                    className="btn-skt"
                    style={{ display: disabledButton ? 'none' : 'inline-block' }}
                  >
                    <span id="contact" onClick={handleSubmitForm}>
                      Let's Go !
                    </span>
                  </a>
                </div>
                <div id="err-msg" className="err-msg">
                  {response}
                </div>
              </form>
            </div>
            </div>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  )
}
